import React from "react";

import FadeInOut from "../../components/FadeInOut/FadeInOut";

import "./HomePage.scss";

class HomePage extends React.Component {
  componentDidMount() {}

  render() {
    return <FadeInOut className="HomePage"></FadeInOut>;
  }
}

export default HomePage;
